module.exports = __webpack_public_path__ + "img/7.4d30e344.png";